import template from './ongCardSwitch.html';
import controller from './ongCardSwitch.controller';
import './ongCardSwitch.scss';

let ongCardSwitchComponent = {
  restrict: 'E',
  bindings: {
    amount: '<',
    onEditAmount: '&',
    minDonation: '<',
    maxDonation: '<',
    cardState: '<',
    onEditCardState: '&',
  },
  template,
  controller,
};

export default ongCardSwitchComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongCard/ongCardSwitch/ongCardSwitch.component.js